'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/* eslint-disable import/prefer-default-export */
var UGC_CONTENT_TYPES = exports.UGC_CONTENT_TYPES = {
  COMMENT: 'comment',
  TAGS: 'tags',
  QUOTATIONS: 'quotations',
  VIDEO: 'video',
  SUMMARY: 'summary',
  SIMILAR_TITLES: 'similar_titles',
  AGE_SUITABILITY: 'age_suitability',
  CONTENT_ADVISORIES: 'content_advisories',
  PRIVATE_NOTE: 'private_note'
};

exports.default = {
  UGC_CONTENT_TYPES: UGC_CONTENT_TYPES
};


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/constants-ugc/lib/index.js
// module id = 119
// module chunks = 1